export const formatDuration = (seconds: number): string => {
  if (seconds < 60) {
    return `${seconds} sec`
  }

  if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60

    return remainingSeconds ? `${minutes} min ${remainingSeconds} sec` : `${minutes} min`
  }

  const totalMinutes = Math.round(seconds / 60)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  return minutes ? `${hours}h ${minutes}m` : `${hours}h`
}
